<template>
  <div class="add-engine">
    <div class="d-flex justify-content-between align-items-center">
      <h2 class="title">Add Engine</h2>
      <div class="ico ico-close" @click="$emit('close-dashcard')">
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="16" cy="16" r="16" fill="#E4E6EB" />
          <g clip-path="url(#clip0)">
            <path
              d="M16.7855 16.0008L22.9482 9.83807C23.1652 9.6211 23.1652 9.26932 22.9482 9.05238C22.7312 8.83543 22.3794 8.83541 22.1625 9.05238L15.9998 15.2151L9.83709 9.05238C9.62012 8.83541 9.26834 8.83541 9.0514 9.05238C8.83446 9.26935 8.83443 9.62113 9.0514 9.83807L15.2141 16.0008L9.0514 22.1635C8.83443 22.3804 8.83443 22.7322 9.0514 22.9492C9.15987 23.0576 9.30207 23.1119 9.44426 23.1119C9.58646 23.1119 9.72862 23.0576 9.83712 22.9492L15.9998 16.7865L22.1625 22.9492C22.2709 23.0576 22.4131 23.1119 22.5553 23.1119C22.6975 23.1119 22.8397 23.0576 22.9482 22.9492C23.1652 22.7322 23.1652 22.3804 22.9482 22.1635L16.7855 16.0008Z"
              fill="#606770"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect
                width="14.2222"
                height="14.2222"
                fill="white"
                transform="translate(8.88867 8.88889)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
    <button
      class="btn btn-primary btn-sm collapsed"
      @click="$emit('show-add-new')"
    >
      +Add New Engine
    </button>
    <h1>Your current engine</h1>
    <div class="engine-list">
      <div
        class="engine"
        v-for="(engine, i) in engines"
        :key="i"
        v-b-tooltip.hover
        title="Edit Engine"
        @click="$emit('show-edit-engine', engine, i)"
      >
        <div class="engine-detail">
          <h3 class="engine-title">
            {{ engine.text }}
          </h3>
          <h6 class="time">at {{ engine.time }}</h6>
          <div class="weeks">
            <div class="week" v-for="(repeat, k) in engine.when" :key="k">
              {{ repeat }}
            </div>
          </div>
        </div>
        <div class="icon">
          <span class="ico">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.52827 3.52859C5.78862 3.26824 6.21073 3.26824 6.47108 3.52859L10.4711 7.52859C10.7314 7.78894 10.7314 8.21105 10.4711 8.4714L6.47108 12.4714C6.21073 12.7317 5.78862 12.7317 5.52827 12.4714C5.26792 12.2111 5.26792 11.7889 5.52827 11.5286L9.05687 8L5.52827 4.4714C5.26792 4.21105 5.26792 3.78894 5.52827 3.52859Z"
                fill="var(--theme-color)"
              />
            </svg>
          </span>
        </div>
      </div>
      <div class="footer">
        <button
          @click="$emit('closeMe')"
          class="btn btn-green btn-sm collapsed"
        >
          Done
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    engines: Array
  },
  data() {
    return {};
  }
};
</script>

<style scoped lang="scss">
.add-engine {
  padding: 24px;
  .title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    color: #474d52;
    margin: 0;
  }
  .engine-list {
    margin-top: 16px;
    max-height: 70vh;
    overflow-y: scroll;
    margin-right: 8px;
    &::-webkit-scrollbar {
      height: 0px;
      width: 8px;
      margin-right: 10px;
    }

    &::-webkit-scrollbar-track {
      background-color: #fff;
    }

    &::-webkit-scrollbar-thumb {
      background: #dddddd;
      border-radius: 16px;
    }
    .footer {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      box-shadow: 0px -4px 12px rgba(0, 0, 0, 0.08);
      display: flex;
      justify-content: center;
      align-items: center;
      .btn-green {
        background-color: #65ea82;
        max-width: 80%;
        margin-top: 12px;
        margin-bottom: 12px;
      }
    }
    .engine {
      margin-bottom: 4px;
      border-radius: 8px;
      cursor: pointer;
      position: relative;
      &.active {
        background: rgba(85, 126, 251, 0.1);
      }
      .ico {
        position: absolute;
        top: 66%;
        right: 20px;
        transform: translateY(-50%);
        cursor: pointer;
      }
      .headline {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        color: #8d99a0;
        margin-bottom: 10px;
      }
      .info {
        padding: 8px 16px;
        display: grid;
        grid-template-columns: 1fr 25px;
        align-items: center;
        img {
          width: 40px;
          height: 40px;
          object-fit: cover;
          border-radius: 50%;
          margin-top: -20px;
        }
        h3 {
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          line-height: 22px;
          color: #474d52;
          margin: 0 0 0 10px;
          display: inline-block;
        }
        span {
          font-weight: bold;
          font-size: 12px;
        }
        .ico {
          cursor: pointer;
        }
      }
    }
  }
}
.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  box-shadow: 0px -4px 12px rgba(0, 0, 0, 0.08);
  display: flex;
  justify-content: center;
  align-items: center;
  .btn-green {
    background-color: #65ea82;
    max-width: 80%;
    margin-top: 12px;
    margin-bottom: 12px;
  }
}
.btn.collapsed {
  padding: 11px;
  width: 100%;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  color: #ffffff;
  border-radius: 8px;
  margin-top: 23px;
}

h1 {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #474d52;
  color: #8d99a0;
  text-align: center;
  margin-top: 16px;
  margin-bottom: 24px;
}
.engine {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 108px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 16px;
}
.engine .engine-detail {
  margin-left: 16px;
}
.engine .engine-title {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
}
.engine .time {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: #8d99a0;
  margin-top: 4px;
}
.weeks {
  display: flex;
  align-items: center;
}
.weeks .week {
  border-radius: 50%;

  width: 24px;
  height: 24px;
  margin: 8px 0px;
  text-align: center;
  line-height: 24px;
  background-color: red;
  color: var(--theme-color);
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(85, 126, 251, 0.1);
  margin-right: 8px;
}
.engine .icon {
  margin-right: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
